var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading && !_vm.error && _vm.devices.length)?_c(_vm.currentDeviceComponent,{tag:"component",attrs:{"devices":_vm.devices,"defaultDevices":_vm.selectedDevices}}):_c('div',{staticClass:"loader"},[(!_vm.error)?_c('StretchLoader'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }